enum SalesIncentiveState {
    Draft = 'Draft',
    Pending = 'Pending',
    Ready = 'Ready',
    Active = 'Active',
}

export default SalesIncentiveState;
